/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Lot_Label_Enqueue_Success_ManyInputs */

const vi_lot_label_enqueue_success_many = /** @type {(inputs: Lot_Label_Enqueue_Success_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã gửi ${i?.count} tem tới máy in kho`)
};

/**

* @param {Lot_Label_Enqueue_Success_ManyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_label_enqueue_success_many = /** @type {((inputs: Lot_Label_Enqueue_Success_ManyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Label_Enqueue_Success_ManyInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_label_enqueue_success_many(inputs)
});